<template>
  <div
    v-if="show"
    class="kiosk-modifiers-overlay"
    @click="$emit('save')"
  >
    <div
      class="kiosk-modifiers-panel"
      @click.stop
    >
      <div class="modifiers-header">
        <button
          class="modifiers-delete-btn"
          @click="$emit('delete')"
        >
          Delete Item
        </button>
        <h2 class="modifiers-title">
          {{ title }}
        </h2>
        <button
          class="modifiers-save-btn"
          @click="$emit('save')"
        >
          Save
        </button>
      </div>
      <div class="modifiers-content">
        <div
          v-for="group in groups"
          :key="group.id"
          class="modifier-group-v2"
        >
          <div class="modifier-group-header-v2">
            <div class="modifier-group-title-v2">
              <span class="modifier-count-badge">{{
                getSelectedCount(group)
              }}</span>
              {{ group.name }}
            </div>
            <div class="modifier-group-rules-v2">
              <span
                class="modifier-rule-pill"
                :class="{ required: getRules(group).required }"
              >
                {{ getRules(group).required ? "Required" : "Optional" }}
              </span>
              <span class="modifier-rule-pill selection">{{
                getRules(group).selectionText
              }}</span>
            </div>
          </div>
          <div class="modifiers-list-v2">
            <div
              v-for="modifier in group.modifiers.filter((m) => m.active)"
              :key="modifier.id"
              class="modifier-item-v2"
              :class="{ selected: isSelected(modifier, group) }"
              @click="$emit('toggle', modifier, group)"
            >
              <div class="modifier-checkbox">
                <KioskIcon
                  v-if="isSelected(modifier, group)"
                  name="check"
                  size="16"
                  stroke-width="2"
                />
              </div>
              <span class="modifier-name-v2">{{ modifier.name }}</span>
              <span
                class="modifier-price-v2"
              >+{{ currency }}{{ (modifier.price || 0).toFixed(2) }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import KioskIcon from "./KioskIcon.vue";

export default {
  name: "ModifiersSidebarV2",
  components: {
    KioskIcon,
  },
  props: {
    show: Boolean,
    title: String,
    groups: Array,
    currency: String,
    getSelectedCount: Function,
    getRules: Function,
    isSelected: Function,
  },
};
</script>

<style scoped>
.kiosk-modifiers-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 100;
  display: flex;
  align-items: center;
  justify-content: center;
  animation: fadeIn 0.3s;
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

.kiosk-modifiers-panel {
  background: white;
  width: 90%;
  max-width: 600px;
  max-height: 90vh;
  border-radius: 16px;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  box-shadow: 0 20px 25px rgba(0, 0, 0, 0.3);
}

.modifiers-header {
  background: #2563eb;
  color: white;
  padding: 16px 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-shrink: 0;
}

.modifiers-delete-btn {
  background: #ef4444;
  color: white;
  border: none;
  padding: 8px 16px;
  border-radius: 8px;
  font-weight: bold;
  cursor: pointer;
  transition: all 0.2s;
}

.modifiers-delete-btn:hover {
  background: #dc2626;
}

.modifiers-title {
  font-size: 18px;
  font-weight: bold;
  margin: 0;
  flex: 1;
  text-align: center;
}

.modifiers-save-btn {
  background: white;
  color: #2563eb;
  border: none;
  padding: 8px 24px;
  border-radius: 8px;
  font-weight: bold;
  cursor: pointer;
  transition: all 0.2s;
}

.modifiers-save-btn:hover {
  background: #eff6ff;
}

.modifiers-content {
  flex: 1;
  overflow-y: auto;
  padding: 20px;
}

.modifier-group-v2 {
  margin-bottom: 32px;
}

.modifier-group-header-v2 {
  margin-bottom: 16px;
}

.modifier-group-title-v2 {
  font-weight: bold;
  font-size: 16px;
  color: #111827;
  margin-bottom: 8px;
  display: flex;
  align-items: center;
  gap: 8px;
}

.modifier-count-badge {
  background: #2563eb;
  color: white;
  font-size: 12px;
  padding: 2px 8px;
  border-radius: 12px;
}

.modifier-group-rules-v2 {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
}

.modifier-rule-pill {
  font-size: 10px;
  font-weight: bold;
  padding: 4px 8px;
  border-radius: 6px;
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

.modifier-rule-pill.required {
  background: #fee2e2;
  color: #991b1b;
}

.modifier-rule-pill:not(.required) {
  background: #dbeafe;
  color: #1e40af;
}

.modifier-rule-pill.selection {
  background: #f3f4f6;
  color: #4b5563;
}

.modifiers-list-v2 {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.modifier-item-v2 {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px;
  border-radius: 8px;
  border: 2px solid transparent;
  cursor: pointer;
  transition: all 0.2s;
  background: #f9fafb;
}

.modifier-item-v2:hover {
  background: #f3f4f6;
  border-color: #e5e7eb;
}

.modifier-item-v2.selected {
  background: #eff6ff;
  border-color: #2563eb;
}

.modifier-checkbox {
  width: 24px;
  height: 24px;
  border: 2px solid #d1d5db;
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  transition: all 0.2s;
}

.modifier-item-v2.selected .modifier-checkbox {
  background: #2563eb;
  border-color: #2563eb;
  color: white;
}

.modifier-checkbox svg {
  width: 16px;
  height: 16px;
}

.modifier-name-v2 {
  flex: 1;
  font-weight: 500;
  color: #111827;
}

.modifier-price-v2 {
  font-weight: bold;
  color: #111827;
}
</style>
